(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["facts-legal-claims"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const superscriptDigits = {
      '⁰': '0',
      '¹': '1',
      '²': '2',
      '³': '3',
      '⁴': '4',
      '⁵': '5',
      '⁶': '6',
      '⁷': '7',
      '⁸': '8',
      '⁹': '9'
    };

    const enhance = (ledger) => {
      if (!ledger || ledger.dataset.enhanced === 'true') return;
      ledger.dataset.enhanced = 'true';

      const main = ledger.closest('main') || document.querySelector('main');
      if (!main) return;

      const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          const parent = node.parentElement;
          if (!parent || !/[⁰¹²³⁴⁵⁶⁷⁸⁹]/.test(node.nodeValue || '')) return NodeFilter.FILTER_REJECT;
          if (ledger.contains(parent) || parent.closest('a, sup, script, style, textarea, select')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);

      textNodes.forEach((node) => {
        const text = node.nodeValue || '';
        const matches = [...text.matchAll(/[⁰¹²³⁴⁵⁶⁷⁸⁹]+/g)];
        if (!matches.length) return;

        const fragment = document.createDocumentFragment();
        let cursor = 0;

        matches.forEach((match) => {
          const number = Number([...match[0]].map((digit) => superscriptDigits[digit]).join(''));
          const target = ledger.querySelector(`[data-claim-number="${number}"]`);
          fragment.append(document.createTextNode(text.slice(cursor, match.index)));

          if (target) {
            const marker = document.createElement('span');
            const superscript = document.createElement('sup');
            marker.className = 'facts-claim-ref';
            superscript.textContent = String(number);
            marker.append(superscript);
            fragment.append(marker);
          } else {
            fragment.append(document.createTextNode(match[0]));
          }

          cursor = match.index + match[0].length;
        });

        fragment.append(document.createTextNode(text.slice(cursor)));
        node.replaceWith(fragment);
      });


    };

    const enhanceAll = (root = document) => root.querySelectorAll('[data-legal-ledger]').forEach(enhance);
    enhanceAll();
    document.addEventListener('shopify:section:load', (event) => enhanceAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usc-entry"] && !Shopify.designMode) return;
  try {
    
(()=>{'use strict';let cleanup=[];function init(){cleanup.forEach(remove=>remove());cleanup=[];const on=(el,event,fn,opts={})=>{if(el){el.addEventListener(event,fn,opts);cleanup.push(()=>el.removeEventListener(event,fn,opts))}};
const root=document.querySelector('.usc-page');if(!root)return;const $=s=>root.querySelector(s), $$=s=>[...root.querySelectorAll(s)];
const messages=JSON.parse(root.querySelector('[data-usc-messages]')?.textContent||'{}');const tr=(key,vars={})=>Object.entries(vars).reduce((text,[name,value])=>text.split('%'+name+'%').join(String(value)),messages[key]||'');
const config=JSON.parse(root.querySelector('[data-usc-config]')?.textContent||'{}');
const testMode=$('[data-usc-test]')?.dataset.uscTest==='true';
const state={stage:1,email:'',confirmed:false,facts:false,usc:false,handle:'',interests:[],submittedAt:''};
const names={essentials:'Daily Essentials',vitality:'Daily Vitality',fitness:'Fitness⁺',brain:'Brain⁺',sleep:'Sleep⁺',skin:'Skin⁺',daily:'Daily All-in-One'};
function count(){return 1+Number(state.facts)+Number(state.usc)}

function profileProperties(){return {
 usc_2026_campaign:'facts_usc_giveaway_2026',
 usc_2026_entry_source:'usc_landing_page',
 usc_2026_terms_version:config.termsVersion,
 usc_2026_signup_requested:true,
 usc_2026_signup_requested_at_client:state.submittedAt,
 usc_2026_marketing_scope:'usc_cooperation',
 usc_2026_marketing_consent_method:'signup_button',
 usc_2026_marketing_consent_version:config.consentVersion,
 usc_2026_marketing_consent_text:$('#usc-signup-consent').textContent.trim(),
 usc_2026_marketing_consent_locale:config.locale,
 usc_2026_instagram_handle:state.handle,
 usc_2026_follow_facts_claimed:state.facts,
 usc_2026_follow_usc_claimed:state.usc,
 usc_2026_ballots_claimed:count(),
 usc_2026_product_interests:[...state.interests]
}}
function signupProperties(){const all=profileProperties();return Object.fromEntries(Object.entries(all).filter(([key])=>!['usc_2026_instagram_handle','usc_2026_follow_facts_claimed','usc_2026_follow_usc_claimed','usc_2026_ballots_claimed','usc_2026_product_interests'].includes(key)))}
function signupPayload(){return {data:{type:'subscription',attributes:{custom_source:'FACTS x USC Giveaway 2026',profile:{data:{type:'profile',attributes:{email:state.email,locale:config.locale,properties:signupProperties(),subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:config.listId}}}}}}
function profilePayload(){return {data:{type:'profile',attributes:{email:state.email,locale:config.locale,properties:profileProperties()}}}}
function signupOpen(){const start=Date.parse(config.start),end=Date.parse(config.end),now=Date.now();return config.enabled===true&&/^[a-zA-Z0-9]+$/.test(config.publicKey||'')&&/^[a-zA-Z0-9]+$/.test(config.listId||'')&&Number.isFinite(start)&&Number.isFinite(end)&&end>start&&now>=start&&now<=end}
function requestError(code,status){const error=new Error(code);error.code=code;error.status=status||0;return error}
const requests=new Set();
async function transmit(path,payload){
 if(testMode)return;
 if(navigator.onLine===false)throw requestError('offline');
 const abort=new AbortController();requests.add(abort);
 const timeout=setTimeout(()=>abort.abort(),15000);
 try{
  const response=await fetch('https://a.klaviyo.com/client/'+path+'?company_id='+encodeURIComponent(config.publicKey),{method:'POST',headers:{'Content-Type':'application/vnd.api+json','Accept':'application/vnd.api+json','revision':'2026-07-15'},body:JSON.stringify(payload),signal:abort.signal,credentials:'omit'});
  if(response.status!==202)throw requestError(response.status===429?'rate_limited':response.status>=500?'service_unavailable':'submission_failed',response.status);
 }catch(error){
  if(error.code&&typeof error.code==='string')throw error;
  throw requestError(abort.signal.aborted?'request_timeout':navigator.onLine===false?'offline':'network_failed');
 }finally{clearTimeout(timeout);requests.delete(abort)}
}

let busy=false,requestVersion=0;
const controls=$$('.usc-stage button, .usc-stage input');
function setBusy(value,message){busy=value;controls.forEach(el=>el.disabled=value);const status=$('#usc-request-status');status.hidden=!value;status.textContent=value?tr(message):'';$('.usc-funnel').setAttribute('aria-busy',String(value))}
function clearErrors(){$('#usc-entry-error').textContent='';$('#usc-save-error').textContent=''}
function showRequestError(error,save){
 const target=$(save?'#usc-save-error':'#usc-entry-error');
 const code=error.code||'submission_failed';
 target.textContent=tr(code==='request_timeout'&&save?'save_timeout':messages[code]?code:save?'save_failed':'signup_failed');
 target.dataset.uscErrorCode=code;target.dataset.uscErrorStatus=String(error.status||0);target.tabIndex=-1;target.focus();
 root.dispatchEvent(new CustomEvent('usc:request-error',{bubbles:true,detail:{operation:save?'save':'signup',code,status:error.status||0}}));
}
async function saveAndGo(stage){
 if(busy)return;syncHandle();clearErrors();setBusy(true,'saving');const version=++requestVersion;let accepted=false;
 try{await transmit('profiles',profilePayload());accepted=true}catch(error){if(version===requestVersion)showRequestError(error,true)}finally{if(version===requestVersion)setBusy(false)}
 if(accepted&&version===requestVersion)go(stage);
}
setBusy(false);
on(window,'pageshow',()=>{if(!busy)setBusy(false)});
on(window,'pagehide',()=>{if(!busy)return;requestVersion++;requests.forEach(request=>request.abort());requests.clear();setBusy(false);showRequestError(requestError('request_timeout'),state.stage!==1)});

function renderOffer(){
  const offer=$('[data-usc-offer]');if(!offer)return;
  const selected=state.interests.length?state.interests:['essentials','vitality','fitness'];
  const cards=[...offer.querySelectorAll('[data-usc-offer-product]')];
  cards.forEach(card=>{
    const key=card.dataset.uscOfferProduct;
    card.hidden=!selected.includes(key);
    const source=$(`input[name="interest"][value="${key}"]`)?.closest('.usc-interest-card');
    const img=card.querySelector('img');const sourceImg=source?.querySelector('img');
    if(img&&sourceImg&&img.getAttribute('src')!==sourceImg.getAttribute('src')){
      img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=sourceImg.src;
    }
    const label=source?.querySelector('strong');
    if(label){card.querySelector('h5').textContent=label.textContent;if(img)img.alt=label.textContent;}
  });
  offer.dataset.visibleCount=String(cards.filter(card=>!card.hidden).length);
}
function render(){
  const n=count(), status=state.confirmed?tr('state_0'):tr('state_1');
  $$('.usc-stage').forEach(el=>el.hidden=el.id!==`usc-stage-${state.stage}`);
  const step=Math.min(state.stage,3),progress=$('.usc-progress-track');
  progress.setAttribute('aria-valuenow',String(step));
  progress.setAttribute('aria-valuetext',tr('ui_progress_step',{step}));
  progress.querySelector('span').style.transform=`scaleX(${step/3})`;
  $('#usc-progress-step').textContent=tr('ui_progress_step',{step});
  $('.usc-progress .usc-ballot-count').hidden=state.stage===1;
  const noticeSlot=$(`#usc-stage-${state.stage} [data-usc-notice-slot]`);
  if(noticeSlot)noticeSlot.appendChild($('#usc-doi-status'));
  $('.usc-progress').hidden=state.stage===4;
  $('#usc-doi-status').hidden=state.stage===1;
  $('#usc-doi-status').classList.toggle('confirmed',state.confirmed);
  $('#usc-doi-heading').textContent=state.confirmed?tr('state_5'):tr('state_6');
  $$('.usc-ballot-count').forEach(el=>el.textContent=tr('ballot_counter',{count:n,status:state.confirmed?tr('state_2'):tr('state_1')}));
  for(const brand of ['facts','usc']){const b=$(`#usc-follow-${brand}`);b.setAttribute('aria-pressed',String(state[brand]));b.innerHTML=state[brand]?tr('follow_pending_html',{}):tr('follow_action_html',{brand:brand==='facts'?'FACTS':'Urban Sports Club'})}
  $('#usc-bonus-skip').hidden=state.facts||state.usc;
  $('#usc-result-count').textContent=String(n);
  $('#usc-result-label').textContent=`${n===1?tr('state_3'):tr('state_4')} ${state.confirmed?tr('state_2'):status}`;
  $('#usc-result-heading').innerHTML=state.confirmed?tr('state_8'):tr('state_9_html');
  $('#usc-result-description').textContent=state.confirmed?tr('state_10'):tr('state_11');
  $('#usc-interest-summary').textContent=state.interests.length?tr('interest_summary',{products:state.interests.map(k=>names[k]).join(', ')}):'';
  renderOffer();
}
function go(stage){state.stage=stage;render();const heading=$(`#usc-stage-${stage} h3`);heading.tabIndex=-1;try{heading.focus({preventScroll:true})}catch{heading.focus()}try{$('.usc-funnel').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'})}catch{$('.usc-funnel').scrollIntoView()}}
function fieldError(input, id, message){const el=$(id);el.textContent=message;el.hidden=!message;input.setAttribute('aria-invalid',String(Boolean(message)))}
function validateEmail(){const input=$('#usc-email');input.value=input.value.trim();const message=!input.value?tr('email_required'):input.validity.typeMismatch?tr('email_invalid'):'';fieldError(input,'#usc-email-error',message);return !message}
function validateEntry(){const emailOK=validateEmail();if(!emailOK)$('#usc-email').focus();return emailOK}
on($('#usc-email'),'input',()=>{if($('#usc-email').getAttribute('aria-invalid')==='true')validateEmail();$('#usc-entry-error').textContent=''});
on($('#usc-entry-form'),'submit',async event=>{
 event.preventDefault();if(busy||!validateEntry())return;
 if(!testMode&&!signupOpen()){$('#usc-entry-error').textContent=tr('signup_unavailable');return}
 clearErrors();state.email=$('#usc-email').value.trim().toLowerCase();state.submittedAt=new Date().toISOString();setBusy(true,'sending');const version=++requestVersion;let accepted=false;
 try{await transmit('subscriptions',signupPayload());accepted=true}catch(error){if(version===requestVersion)showRequestError(error,false)}finally{if(version===requestVersion)setBusy(false)}
 if(accepted&&version===requestVersion)go(2);
});
function syncHandle(){const handle=$('#usc-instagram').value.trim().replace(/^@/,'').toLowerCase();if(handle!==state.handle&&(state.facts||state.usc)){$('#usc-follow-error').textContent=tr('state_12');state.facts=false;state.usc=false;render()}state.handle=handle}
on($('#usc-instagram'),'input',syncHandle);on($('#usc-instagram'),'change',syncHandle);

for(const brand of ['facts','usc'])on($(`#usc-follow-${brand}`),'click',()=>{if(busy)return;syncHandle();if(!/^(?!.*\.\.)[a-z0-9_](?:[a-z0-9_.]{0,28}[a-z0-9_])?$/.test(state.handle)){$('#usc-follow-error').textContent=tr('state_13');$('#usc-instagram').focus();return}$('#usc-follow-error').textContent='';state[brand]=!state[brand];render();if(state.facts&&state.usc)saveAndGo(3)});
on($('#usc-bonus-next'),'click',()=>saveAndGo(3));on($('#usc-bonus-skip'),'click',()=>saveAndGo(3));on($('#usc-back-bonus'),'click',()=>go(2));
on($('#usc-interest-form'),'submit',e=>{e.preventDefault();state.interests=$$('input[name=interest]:checked').map(el=>el.value);saveAndGo(4)});
on($('#usc-interest-skip'),'click',()=>{state.interests=[];$$('input[name=interest]').forEach(el=>el.checked=false);saveAndGo(4)});
const copyButton=$('[data-usc-copy]');
on(copyButton,'click',async()=>{
  const result=$('#usc-copy-status');
  try{
    if(!navigator.clipboard?.writeText)throw new Error('clipboard_unavailable');
    await navigator.clipboard.writeText(copyButton.dataset.uscCopy);
    result.textContent=copyButton.dataset.copied;
  }catch{result.textContent=copyButton.dataset.failed}
});
const legalDialog=$('#usc-legal-dialog');let legalTrigger=null,previousOverflow='';
function closeLegal(){if(typeof legalDialog.close==='function')legalDialog.close();else legalDialog.removeAttribute('open');if(legalDialog.classList.contains('usc-dialog-fallback')){legalDialog.classList.remove('usc-dialog-fallback');document.body.style.overflow=previousOverflow}if(legalTrigger)legalTrigger.focus()}
$$('[data-dialog]').forEach(b=>on(b,'click',()=>{const content=$('#usc-legal-content');content.textContent='';content.appendChild($(`#${b.dataset.dialog}`).content.cloneNode(true));legalTrigger=b;if(typeof legalDialog.showModal==='function')legalDialog.showModal();else{previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';legalDialog.classList.add('usc-dialog-fallback');legalDialog.setAttribute('open','');legalDialog.setAttribute('role','dialog');legalDialog.setAttribute('aria-modal','true');$('#usc-close-dialog').focus()}}));
on($('#usc-close-dialog'),'click',closeLegal);on(legalDialog,'click',e=>{if(e.target===legalDialog){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeLegal()}});
on(document,'click',e=>{if(legalDialog.classList.contains('usc-dialog-fallback')&&legalDialog.hasAttribute('open')&&!legalDialog.contains(e.target)){e.preventDefault();e.stopImmediatePropagation();closeLegal()}},true);
on(document,'focusin',e=>{if(legalDialog.classList.contains('usc-dialog-fallback')&&legalDialog.hasAttribute('open')&&!legalDialog.contains(e.target))$('#usc-close-dialog').focus()});
on(document,'keydown',e=>{if(!legalDialog.classList.contains('usc-dialog-fallback')||!legalDialog.hasAttribute('open'))return;if(e.key==='Escape'){e.preventDefault();closeLegal()}else if(e.key==='Tab'){const items=Array.from(legalDialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter(el=>!el.disabled&&el.tabIndex>=0),first=items[0],last=items[items.length-1];if(e.shiftKey&&(document.activeElement===first||!legalDialog.contains(document.activeElement))){e.preventDefault();last.focus()}else if(!e.shiftKey&&(document.activeElement===last||!legalDialog.contains(document.activeElement))){e.preventDefault();first.focus()}}});

const prizeTabs=$$('[role=tab]');
function selectPrize(index){prizeTabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===index));t.tabIndex=i===index?0:-1;$('#'+t.getAttribute('aria-controls')).hidden=i!==index});requestAnimationFrame(updateCarousels)}
prizeTabs.forEach((t,index)=>{on(t,'click',()=>selectPrize(index));on(t,'keydown',e=>{let next;if(e.key==='ArrowRight'||e.key==='ArrowLeft')next=1-index;else if(e.key==='Home')next=0;else if(e.key==='End')next=1;else return;e.preventDefault();selectPrize(next);prizeTabs[next].focus()})});
$$('.usc-swipe-track').forEach(track=>{
 on(track,'keydown',e=>{if(e.target!==track||!['ArrowRight','ArrowLeft'].includes(e.key))return;e.preventDefault();const card=track.firstElementChild;if(card)track.scrollBy({left:(card.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||0))*(e.key==='ArrowRight'?1:-1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})});
});
const carouselUpdates=[];
$$('[data-carousel]').forEach(control=>{const track=$('#'+control.dataset.carousel);if(!track)return;const cards=[...track.children],counter=control.querySelector('.usc-carousel-count'),line=control.querySelector('.usc-carousel-line i');let active=0;
 function update(){if(!track.clientWidth)return;const left=track.getBoundingClientRect().left;active=cards.reduce((best,card,i)=>Math.abs(card.getBoundingClientRect().left-left)<Math.abs(cards[best].getBoundingClientRect().left-left)?i:best,0);counter.textContent=String(active+1).padStart(2,'0')+' / '+String(cards.length).padStart(2,'0');line.style.width=(100/cards.length)+'%';line.style.transform='translateX('+(active*100)+'%)';control.querySelector('[data-dir="-1"]').disabled=active===0;control.querySelector('[data-dir="1"]').disabled=active===cards.length-1;}
 function slide(index){const target=Math.max(0,Math.min(cards.length-1,index));track.scrollBy({left:cards[target].getBoundingClientRect().left-track.getBoundingClientRect().left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}
 control.querySelectorAll('[data-dir]').forEach(b=>on(b,'click',()=>slide(active+Number(b.dataset.dir))));on(track,'scroll',update,{passive:true});on(track,'keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();slide(active+(e.key==='ArrowRight'?1:-1))}});carouselUpdates.push(update);update();
});
function updateCarousels(){carouselUpdates.forEach(update=>update())}
on(window,'resize',updateCarousels);
if($('#usc-entry-form'))render();
}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);document.addEventListener('shopify:block:select',e=>{if(e.target.closest('#usc-prize-daily'))document.querySelector('#usc-tab-daily')?.click();else if(e.target.closest('#usc-prize-bundle'))document.querySelector('#usc-tab-bundle')?.click()});document.addEventListener('shopify:section:unload',()=>Promise.resolve().then(init));})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usc-trust"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = () => {
    document.querySelectorAll('.usc-trust-grid').forEach(track => {
      if (track.dataset.dragBound) return;
      track.dataset.dragBound = 'true';
      let pointer = null, startX = 0, startScroll = 0, dragged = false;
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointer = event.pointerId;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        dragged = false;
      });
      track.addEventListener('pointerleave', event => {
        if (event.pointerId === pointer && !track.hasPointerCapture(pointer)) pointer = null;
      });
      track.addEventListener('dragstart', event => event.preventDefault());
      track.addEventListener('pointermove', event => {
        if (event.pointerId !== pointer) return;
        const distance = event.clientX - startX;
        if (!dragged && Math.abs(distance) < 6) return;
        if (!dragged) {
          dragged = true;
          track.setPointerCapture(pointer);
          track.classList.add('is-dragging');
        }
        event.preventDefault();
        track.scrollLeft = startScroll - distance;
      });
      const end = event => {
        if (event.pointerId !== pointer) return;
        if (track.hasPointerCapture(pointer)) track.releasePointerCapture(pointer);
        pointer = null;
        track.classList.remove('is-dragging');
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('lostpointercapture', () => {
        pointer = null;
        track.classList.remove('is-dragging');
      });
      track.addEventListener('click', event => {
        if (!dragged) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }, true);
    });
  };
  bind();
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();
})();
